module.exports = __webpack_public_path__ + "media/images/emblems/Elgg-blazon-8f532bf3127201acd26c11ac0e69a156.svg";